module.exports = __webpack_public_path__ + "img/senior-virtual-2022-robomission.49caabcf.png";